<template>
    <div class="overview-line">
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <credential style="height: 100%!important;" />
            </div>
        </div>
    </div>
</template>

<script>
import Credential from './Credential'

export default {
    name: 'Overview',
    components: { Credential },
}
</script>

<style scoped>
.overview-line {
    margin-top: 1rem;
}
</style>
